import React, { useContext, useState } from 'react';
import { FlowContext } from '../../core/flow-engine';
import ExistingFundsTable from '../../components/ExistingFundsTable/ExistingFundsTable';
import { toggleFund } from './util';
import { isEmptyObject } from '../../core/util';
import PhoneNumber from '../../components/PhoneNumber/PhoneNumber';
import { MFBeaconButton } from '../../components/Beacon/BeaconComponents';
import Heading from '../../components/Typography/Heading/Heading';
import SubHeading from '../../components/Typography/SubHeading/SubHeading';
import styles from './style.css';
import { generateGeneralTestID } from '../../generateAutomationTestIDs';

const ExistingFundsScreen = () => {
  const { appState, next, back } = useContext(FlowContext);
  const {
    store: { existingAgreements, app }
  } = appState;
  const { existingAccounts = [], newInvestments } = app;

  // fetch selected existing agreements when user
  // lands on existing funds screen via review screen or
  // comes back from the previous screen
  const selectedFundsAgreementIds = existingAccounts?.map(
    ({ agreementID }) => agreementID
  );
  const selectedExistingAgreements = existingAgreements?.filter(
    ({ agreementID }) => {
      return selectedFundsAgreementIds?.includes(agreementID);
    }
  );

  const newInvestmentsExists = newInvestments?.length > 0;

  // intiate the selected funds state with selected existing agreements
  // incase user lands on existing funds screen via review screen or
  // comes back from the previous screen, so that we pre-select the
  // existing fund checkboxes, based on the previous selection of the user
  const [selectedFunds, setSelectedFunds] = useState(
    selectedExistingAgreements
  );
  const [newFundStatus, setNewFundStatus] = useState(newInvestmentsExists);

  return (
    <div className="container">
      <Heading text="Select Funds" />
      <SubHeading text="Choose from the list below, add news funds, or both." />

      <ExistingFundsTable
        funds={existingAgreements}
        toggleFund={toggleFund}
        selectedFunds={selectedFunds}
        setSelectedFunds={setSelectedFunds}
        selectedFundsAgreementIds={selectedFundsAgreementIds}
        newFundStatus={newFundStatus}
        setNewFundStatus={setNewFundStatus}
      />

      <div className="button-container">
        <MFBeaconButton
          variant="primary"
          size="normal"
          id="existingAgreementsContinue"
          data-name={generateGeneralTestID('ExistingFunds', 'ContinueButton')}
          onClick={next(selectedFunds, 'ExistingAgreementScreen')}
          disabled={!newFundStatus && isEmptyObject(selectedFunds)}
          label="Continue"
        />
        <MFBeaconButton
          variant="secondary"
          size="normal"
          onClick={back()}
          id="existingAgreementsBack"
          className="beacon-button-margin-override"
          data-name={generateGeneralTestID('ExistingFunds', 'BackButton')}
          label="Back"
        />
        <PhoneNumber screen="InvestmentScreen" />
      </div>
      <style jsx>{styles}</style>
    </div>
  );
};

export default ExistingFundsScreen;
